module.exports = __webpack_public_path__ + "media/images/recruit/recruitmentlist/il_designer-d7babd6963257ddfeb14a53ac5419f62.png";